import { Component, OnInit } from '@angular/core';
import { RegService } from '../shared/Reg.Service';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {

  public step = 'one';
  public data: any;

  constructor(private regService: RegService, private appInsightsService: AppInsightsService) { }

  ngOnInit() {
  	 this.appInsightsService.logPageView("Trust Registration UI Page View");
  }

}

